import { AlertTriangle } from 'lucide-react';
import { FillVariable } from '../utils';
import { Label } from '@/components/ui-kit/label';
import RenderFormControl from './render-control';

type Props = {
  invalid: boolean;
  setValue: (name: string, value: string) => void;
  setCompanyValue: (name: string, value: string) => void;
  v: FillVariable;
  opts?: { subLabel?: string; forceRequired?: boolean; note?: string };
  value: string;
};

export const RenderTextForm = (props: Props) => {
  const { invalid, opts, v, value: val, setValue, setCompanyValue } = props;
  const id = `fill-${v.name}`;
  const required = v.required || !!opts?.forceRequired;
  const errMsg =
    v.type === 'email' && val !== '' ? 'Enter a valid email address.' : 'This field is required.';
  return (
    <div className="space-y-2" data-field-error={invalid ? 'true' : undefined}>
      <Label
        htmlFor={id}
        className="flex items-center gap-1 text-sm font-medium text-[hsl(var(--fg))]"
      >
        {opts?.subLabel ?? v.label}
        {required && (
          <span className="text-destructive" aria-hidden>
            *
          </span>
        )}
      </Label>
      <RenderFormControl
        v={v}
        invalid={invalid}
        setCompanyValue={setCompanyValue}
        setValue={setValue}
        value={val}
      />
      {(v.helpText || opts?.note) && (
        <p id={`${id}-help`} className="text-xs text-globe-grey">
          {opts?.note ?? v.helpText}
        </p>
      )}
      {invalid && (
        <p
          id={`${id}-error`}
          role="alert"
          className="flex items-center gap-1 text-xs text-destructive"
        >
          <AlertTriangle className="h-3 w-3" />
          {errMsg}
        </p>
      )}
    </div>
  );
};
